// @ts-nocheck

import { jwtDecode } from 'jwt-decode';
import { ROUTES } from "../../../utilities/constant";
import { useNavigate } from 'react-router-dom'; // Assuming you're using React Router for navigation
import { toast } from "sonner";
import { friendlyApiError } from "../../../utilities/apiErrorMessage";
import { Storage } from "../../../utilities/setting";

const fallbackNavigate = (path) => {
    if (typeof window !== 'undefined' && window?.location) {
        window.location.assign(path);
    }
};

const onLoginPage = () => {
    if (typeof window === 'undefined' || !window?.location) {
        return false;
    }

    return window.location.pathname.replace(/\/+$/, '').endsWith(`/${ROUTES.LOGIN}`);
};

export const checkAuthSession = async ({
    navigate,
    setToastProps,
    setShowToast,
} = {}) => {
    try {
        const token = Storage.getItem('access_token');
        if (!token) {
            throw new Error('Missing access_token');
        }

        const { exp } = jwtDecode(token);
        if (!exp || exp * 1000 < Date.now()) {
            Storage.clearAll();
            throw new Error('Expired access_token');
        }

        return true;
    } catch (error) {
        console.log('Error decoding token:', error);
        errorCheck(error, navigate ?? fallbackNavigate, setToastProps, setShowToast);
        return false;
    }
};

export const useAuth = () => {
    const navigate = useNavigate();

    const checkAuth = async (setToastProps, setShowToast) => {
        await checkAuthSession({ navigate, setToastProps, setShowToast });
    };

    return { checkAuth };
};

export const errorCheck = (err, navigate, setToastProps, setShowToast) => {
    try {
        let errorMessage = "";

        if (typeof err === "string") {
            errorMessage = err;
        } else if (Array.isArray(err)) {
            errorMessage = err.join(" ");
        } else if (typeof err === "object" && err !== null) {
            errorMessage =
                err?.message ||
                err?.error ||
                err?.response?.data?.message ||
                JSON.stringify(err);
        }

        errorMessage = errorMessage.toLowerCase();

        const isAuthError =
            errorMessage.includes("token") ||
            errorMessage.includes("jwt") ||
            errorMessage.includes("unauthorized") ||
            errorMessage.includes("401") ||
            errorMessage.includes("session expired");

        if (!isAuthError) {
            return;
        }

        // Nothing to expire, and redirecting here is what caused the loop.
        if (onLoginPage()) {
            return;
        }

        if (typeof navigate === "function") {
            toast.error("Session Expired");

        // setShowToast(true);

        Storage.clearAll();
        setTimeout(() => {
            window.location.replace(`/${ROUTES.LOGIN}`);
            if (typeof setShowToast === 'function') {
                setShowToast(false);
            }
        }, 1000);
        }
    } catch (err) {
        toast.error(friendlyApiError(err) || 'Something went wrong');
    }
};
